import React, { useEffect, useState } from "react";
import {
  Input,
  Form,
  Button,
  Row,
  Col,
  Tabs,
  Space,
  Upload,
  Typography,
  Select,
  Tooltip,
  message

} from "antd";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../../common";
import "./Feedback.scss";
import { InboxOutlined, PlusOutlined } from "@ant-design/icons";
import { deleteRequest, postRequest } from "../../api/http";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import backBtn from "../../assets/images/back-arrow.svg";
import { getAuthToken } from "../../utils/helper";

function FeedBack() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { Dragger } = Upload;
  const [fileList, setFileList] = useState([]);
  const [fileLoader, setFileLoader] = useState(true);
  const { micrositeId } = useParams();
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState(null);
  const [form] = Form.useForm();
  const [fileSizeOk, setFileSizeOk] = useState(false);

  const lastPage = sessionStorage.getItem("page");
  const checkFile = (file) => {
    const maxSize = 2.5 * 1024 * 1024;
    const isSizeValid = file.size <= maxSize;

    if (!isSizeValid) {
      setFileSizeOk(false);
      toast.error("File size exceeds 2.5MB!");
    } else {
      setFileSizeOk(true);
    }

    return isSizeValid;
  };

  const onFinish = async (values) => {
    try {
      if (file) {
        if (fileSizeOk) {
          setLoading(true);
          if (values && values.message && values.feedbackAboutEnum) {
            var formData = new FormData();
            if (file) {
              formData.append("file", file, fileName);
            }
            const formatedData = {
              feedbackAboutEnum: values.feedbackAboutEnum,
              message: values.message,
              partnerId: sessionStorage.getItem("partnerId"),
              userRole: 'PARTNER_ADMIN'
            };
            const json = JSON.stringify(formatedData);
            const blob = new Blob([json], {
              type: "application/json",
            });
            formData.append("supportAndFeedbackInput", blob);
            const response = await postRequest(
              userServiceApi.feedbackForm(),
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getAuthToken()}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            if (response) {
              setFileName(null);
              toast.success("Feedback sent successfully");
              setFileSizeOk(false);
              setLoading(false);
            }
          }
        } else {
          toast.error("File size exceeds 2.5MB!");
          setLoading(false);
        }
        setLoading(false);
      } else {
        setLoading(true);
        if (values && values.message && values.feedbackAboutEnum) {
          var formData = new FormData();
          const formatedData = {
            feedbackAboutEnum: values.feedbackAboutEnum,
            message: values.message,
            partnerId: sessionStorage.getItem("partnerId"),
            userRole: 'PARTNER_ADMIN'
          };
          const json = JSON.stringify(formatedData);
          const blob = new Blob([json], {
            type: "application/json",
          });
          formData.append("supportAndFeedbackInput", blob);
          const response = await postRequest(
            userServiceApi.feedbackForm(),
            formData,
            {
              headers: {
                Authorization: `Bearer ${getAuthToken()}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response) {
            setFileName(null);
            toast.success("Feedback sent successfully");
            setFileSizeOk(false);
            setLoading(false);

          }
        }
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  // const handleUploadAPI = ({ file }) => {
  //   const fileName = file.name;
  //   setFileName(fileName);
  //   const blob = new Blob([file], {
  //     type: "multipart/form-data",
  //   });
  //   setFile(blob);


  //   if (Object.values(fileList).length > 0) {
  //   } else {
  //     setFileList((pre) => {
  //       return { ...pre, [file.uid]: file };
  //     });
  //   }
  // };

  // const uploadProps = {
  //   accept: ".pdf, .jpeg, .png, .jpg",
  //   beforeUpload: checkFile,
  //   maxCount: 1,
  //   multiple: false,
  //   showUploadList: false,
  //   customRequest: handleUploadAPI,
  // };


  //  const [fileList, setFileList] = useState([]);
  // const [fileName, setFileName] = useState("");

  const handleUploadAPI = ({ file, onSuccess, onError }) => {
    try {
      const fileName = file.name;
      setFileName(fileName);

      const blob = new Blob([file], {
        type: "multipart/form-data",
      });

      // store file in state
      setFileList([
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: URL.createObjectURL(file), // preview
        },
      ]);

      // Simulate API success
      setTimeout(() => {
        onSuccess("ok");
      }, 500);
    } catch (err) {
      onError(err);
    }
  };

  const uploadProps = {
    accept: ".pdf,.jpeg,.png,.jpg",
    beforeUpload: (file) => {
      const isLt2M = file.size / 1024 / 1024 < 2.5;
      if (!isLt2M) {
        message.error("File must smaller than 2.5MB!");
        return Upload.LIST_IGNORE;
      }
      return true;
    },
    maxCount: 1,
    multiple: false,
    listType: "picture", // 👈 picture mode (or use "picture-card")
    fileList,
    customRequest: handleUploadAPI,
    onChange(info) {
      setFileList(info.fileList);
    },
    onRemove(file) {
      setFileList([]);
      setFileName("");
    },
  };


  if (loading) return <LoadingView message="Loading..." />;

  return (
    <>
      <div className="tabContainer">
        <div className="main-container" style={{ paddingTop: "5px" }}>
          <div className="header-container">
            <div className="backbtn-container">
              <img src={backBtn}
                onClick={() => {
                  lastPage === "home" ?
                    navigate('/partner-org') :
                    lastPage === "edit-carousel" ?
                      navigate('/carousel') :
                      lastPage === "full-members" ?
                        navigate('/full-members') :
                        lastPage === "hub-members" ?
                          navigate('/hub-members') :
                          navigate('/partner-org')
                }}
                alt="" />
              <p>Feedback & Support</p>
            </div>
          </div>


          <div className="formInfoStyle">

            <Form
              //   labelCol={{ span: 7 }}
              form={form}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 10 }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    label="I want to"
                    name="feedbackAboutEnum"
                    rules={[
                      {
                        required: true,
                        message: "Feedback type is required",
                      },
                    ]}
                  >
                    <Select
                      name="feedbackAboutEnum"
                      placeholder="I want to.."
                    >
                      <Select.Option value="COMMENT">
                        Leave a comment
                      </Select.Option>
                      <Select.Option value="REPORT">
                        Report a bug
                      </Select.Option>
                      <Select.Option value="SUGGESTION">
                        Suggest an improvement
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "Feedback message is required",
                      },
                    ]}
                    label="Feedback message"
                    name="message"
                  >
                    <Input.TextArea
                      rows={3}
                      maxLength={300}
                      showCount
                      placeholder="Feedback message"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="formInfoRow">
                <div className="formInfoCol">
                  <Form.Item
                    className="doc"
                    label="Feedback document"
                    name="feedbackDocument"
                  >
                    <Tooltip title="Upload image or pdf with size less than 2.5MB. Recommended image dimensions: 1280x720 pixels">
                      <Upload {...uploadProps}>
                        {fileList.length === 0 && (
                          <>
                            <div className="uploadBox">
                              <PlusOutlined />
                              <div className="uploadText"> No document uploaded</div>
                            </div>

                          </>
                        )}
                      </Upload>
                    </Tooltip>

                    {/* <div className="existing">
                      {fileName ? (
                        <Space className="fileList-Item">
                          <Typography.Text>{fileName}</Typography.Text>
                        </Space>
                      ) : (
                        <Space className="fileList-Item">
                          <Typography.Text>No document uploaded</Typography.Text>
                        </Space>
                      )}
                    </div> */}
                  </Form.Item>
                </div>
              </div>

            </Form >
            <div className="formInfoRow">
              <div className="formInfoCol">
                <div className="form-btn-container">
                  <Button className="form-save-btn" htmlType="submit" onClick={() => form.submit()}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="footer">
        <div
          className="footer-content"
          onClick={() => window.open("https://www.connectsu.co.uk/", "_blank")}
          style={{ cursor: "pointer" }}
        >
          <div className="footer-logo">
            <img
              src={require("../../assets/images/PoweredNew.png")}
              alt="company logo"
            />
          </div>
        </div>
      </div> */}
    </>
  );
}

export default FeedBack;
